<div class="component full-width full-height">
    <canvas #canvas
            class="full-width full-height"
    ></canvas>
    <img #leftFootIcon class="foot d-none" src="./assets/icons/device_plate_foot_left_black.png" alt="foot icon"/>
    <img #rightFootIcon class="foot d-none" src="./assets/icons/device_plate_foot_right_black.png" alt="foot icon"/>
    <img #kinventLogo class="d-none" src="./assets/kinvent_logo_500x500.png" alt="kinvent logo"/>
</div>
